import type { ReactNode } from "react";

/** Design switches layouts at 768px: mobile below, desktop at and above. */
export function Responsive({
  mobile,
  desktop,
}: {
  mobile: ReactNode;
  desktop: ReactNode;
}) {
  return (
    <>
      <div className="md:hidden">{mobile}</div>
      <div className="hidden md:block">{desktop}</div>
    </>
  );
}
